import axios from "../config/axios";
import Constants from "../data/Constants";

export const getMediaList = async (query, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.MEDIA.ALL, { params: query })
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleMedia = async (id, pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.MEDIA.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const createMedia = async (data) => {
  const formData = new FormData();

  for (var key in data) {
    formData.append(key, data[key]);
  }

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await axios
    .post(Constants.ENDPOINTS.MEDIA.CREATE_SINGLE, formData, config)
    .then((res) => {
      return res.data.result;
    });
};
